import { FastAverageColor } from 'fast-average-color';

const fac = new FastAverageColor()

export const getAverageColor = (video) => {
  try {
    let color = fac.getColor(video)
    return color
  } catch (e) {
  }
  return undefined
}